import _ from "lodash";
import {
  inline,
} from "CommonState/action-helpers";
import apifetch from "CommonCore/apifetch";
import {
  ENDPOINT_CATALOGS,
} from "App/constants";

export function retrieveKataloge() {
  return async function(dispatch) {
    const data = await apifetch(ENDPOINT_CATALOGS);

        /*
         * Service liefert ein einzelnes Objekt, mit einer Property je Tabellenname. Darin jeweils ein Array von Objekten
         * die den Rows der Katalogtabelle entsprechen
         */

    const allCatalogs = data;

    const getKey = k => {
          // Primärschlüsselnamen zur Tabelle ermitteln. Hier: Generieren des Namens mit bekanntem Benennungsschema
      try {
        const anyfld = Object.keys(allCatalogs[k][0])[0];
        const prefix = anyfld.split("_")[0];
        return prefix + "_id";
      } catch(err) {
        return ""; // keine Daten oder unbekanntes Feldnamenschema
      }
    };

        // Listen zusätzlich als Dictionaries ablegen (k_tabelle -> k_tabelleLookup)
    _.keys(allCatalogs).forEach(k => allCatalogs[`${ k }Lookup`] = _.keyBy(allCatalogs[k], getKey(k)));

    const modifies = _.mapValues(allCatalogs, () => "discard");

    dispatch(inline(modifies, state => _.assign(state, allCatalogs)));
  };
}
